const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/analyze/groups.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
// Admin Group Analyze Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/analyze/groups")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    groupIds: z.array(z.number()).optional(),
    tablePage: z.number().int().optional(),
    tablePageSize: z.number().int().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "{erg_p}",
      description: "Page title"
    })
  }
});